import { createApp, type App } from "vue";
import BunnyLoader from "@/components/bunnyLoader.vue";

// The full screen loader is built by hand rather than rendered by a parent,
// so the working indicator is mounted into it as its own tiny app. It has to
// be unmounted again on the way out, or the banner's timers and frames keep
// running after the element is gone.
let loaderApp: App | null = null;

export function fullScreenLoader() {
    // 이미 존재하면 다시 만들지 않음
    if (document.getElementById("full-screen-loader")) {
        return document.getElementById("full-screen-loader")!;
    }

    const loader = document.createElement("div");
    loader.id = "full-screen-loader";
    loader.style.position = "fixed";
    loader.style.top = "0";
    loader.style.left = "0";
    loader.style.width = "100%";
    loader.style.height = "100%";
    // Theme-aware overlay: 85% of the active @paper token so the loader
    // dims the page on both light and dark themes without washing out the
    // mark (which uses @ink).
    loader.style.backgroundColor =
        "color-mix(in srgb, var(--bq-paper) 85%, transparent)";
    loader.style.display = "flex";
    loader.style.flexDirection = "column";
    loader.style.justifyContent = "center";
    loader.style.alignItems = "center";
    loader.style.zIndex = "9999";
    loader.style.pointerEvents = "all";

    const mark = document.createElement("div");
    loader.appendChild(mark);
    loader.setAttribute("translate", "no");

    const host = document.body || document.documentElement; // body가 없으면 html에 직접 추가
    host.appendChild(loader);
    loaderApp = createApp(BunnyLoader, { overlay: false });
    loaderApp.mount(mark);
    return loader;
}

export function removeFullScreenLoader() {
    if (loaderApp) {
        loaderApp.unmount();
        loaderApp = null;
    }
    // remove() rather than body.removeChild(): the loader may have been
    // appended to the html element when there was no body yet.
    document.getElementById("full-screen-loader")?.remove();
}

// export function showDropDown(e) {
//     let getCustomSelect = document.getElementsByClassName("customSelect");
//     let currentTarget = e.currentTarget;
//     for (let i = 0; i < getCustomSelect.length; i++) {
//         if (currentTarget.isEqualNode(getCustomSelect[i])) {
//             continue;
//         }

//         let getMoreVert = getCustomSelect[i].lastChild;
//         getMoreVert.style.display = "none";
//     }

//     let getMoreVert = currentTarget.lastChild;
//     if (getMoreVert.style.display === "none") {
//         getMoreVert.style.display = "block";
//     } else {
//         getMoreVert.style.display = "none";
//     }
// };

// let hideMoreVert = (e) => {
//     let getMoreVert = document.getElementsByClassName("moreVert");

//     for (let i = 0; i < getMoreVert.length; i++) {
//         if (
//             getMoreVert[i].style.display == "block" &&
//             !getMoreVert[i].contains(e.target)
//         ) {
//             getMoreVert[i].style.display = "none";
//         }
//     }
// };

// document.addEventListener("click", hideMoreVert);
